// environment settings that are used when the CI deploys to the staging environment
import { Environment } from './types';

export const environment: Environment = {
  production: true,
  name: 'stage',
  sentry: {
    enabled: true,
    showDialog: true,
  },
  sessionServer: 'soulmachines.cloud',
  deploymentSubdomains: [
    {
      name: 'Default',
      subdomain: 'multi-stg',
    },
    {
      name: 'Azure',
      subdomain: 'multi-stg.prod.az',
    },
  ],
  apiConfig: {
    url: 'https://config-service-stg.soulmachines.cloud/api/v1',
  },
  apiOrg: {
    url: 'https://entity-service-stg.soulmachines.cloud/api/v1',
    urlV2: 'https://entity-service-stg.soulmachines.cloud/api/v2',
  },
  apiDesigner: {
    version: '2.4',
  },
  auth0Config: {
    audience: 'https://api.studio.soulmachines.cloud',
    domain: 'authenticate-studio-stg.soulmachines.cloud',
    clientId: 'HJ10Q90hQMayM3CK4NhtkNXwbidd2cZA',
  },
  analytics: {
    url: 'https://analytics-service-stg.soulmachines.cloud/api/v1',
  },
  soulMachinesOrgId: 1,
  featureFlags: {
    'project-interactive-preview': true,
    'project-preview-speech-logging': false,
    'blender-stylized-mode': false,
    'insights-conversation-nodes': true,
    'manage-skills-form': true,
    'project-legal-agreements': false,
    'project-knowledge': true,
    'dashboard-conversation-count-usage-indicator': false,
    'navbar-organization-menu': true,
    'user-notification-receipt': false,
    'dashboard-usage-indicators': true,
    'admin-notification-contents': true,
    'project-sidebar-validation': true,
  },
  segment: {
    writeKey: '',
  },
  posthog: {
    apiKey: 'phc_njB6owfzxxJcs8oEU2rhNZFTpcaQ3yinyAVXVapZgQ26',
    apiHost: 'https://us.i.posthog.com',
    app_release: 'ddna-studio@stg',
  },
  projectThemes: [
    { text: 'auckland-sales-theme_prerelease', value: 'auckland-sales-theme_prerelease' },
    { text: 'auckland-sales-theme_stable', value: 'auckland-sales-theme_stable' },
  ],
  gtmId: 'GTM-TCM59BKD',
};
